const { google } = window;

Array.from(document.querySelectorAll('.googleMaps'))
  .forEach((ele) => {
    const center = new google.maps.LatLng(ele.dataset.lat, ele.dataset.lng);

    const map = new google.maps.Map(ele, {
      center,
      zoom: 15,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: false,
    });

    new google.maps.Marker({ // eslint-disable-line
      position: center,
      map,
    });
  });
